import { render, staticRenderFns } from "./FileNameView.vue?vue&type=template&id=660fe33d&scoped=true"
import script from "./FileNameView.vue?vue&type=script&lang=js"
export * from "./FileNameView.vue?vue&type=script&lang=js"
import style0 from "./FileNameView.vue?vue&type=style&index=0&id=660fe33d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660fe33d",
  null
  
)

export default component.exports